module.exports = __webpack_public_path__ + "media/svg/mg-0cc44916.svg";